<template>
  <div class="choch">
    <div class="container _py-16 _px-4">
      <div
        class="choch__header d-flex direction-lg-row direction-column justify-center align-center"
      >
        <div class="choch__header-first">404</div>
        <div class="choch__header-second">
          <div class="choch__header-second_title">{{ $t('404.title') }}</div>
          <div class="choch__header-second_descr _mt-4">
            {{ $t('404.descr') }}
          </div>
        </div>
      </div>
      <div class="choch__body _mt-8">
        <div class="choch__body-title _mb-4">{{ $t('404.list-title') }}</div>
        <ul class="choch__body-list _mb-8">
          <li v-for="(text, i) in $t('404.list')" :key="i" v-html="text"></li>
        </ul>
        <div class="choch__body-title _mb-4">{{ $t('404.text') }}</div>
        <AppBtn>
          <router-link
            class="choch__body-home"
            :to="helpers.buildRoute({ name: 'Home' })"
          >
            <div class="_px-8 _py-4">
              <span class="_tc-white _fs-16 _lh-24">{{ $t('404.btn') }}</span>
            </div>
          </router-link>
        </AppBtn>
      </div>
    </div>
  </div>
</template>

<script>
import AppBtn from '@/components/UI/buttons/AppBtn'
import { mapGetters } from 'vuex'
export default {
  metaInfo() {
    return { title: this.$t('404.title') }
  },
  components: { AppBtn },
  name: 'Choch',
  computed: {
    ...mapGetters(['user']),
  },
  watch: {
    async user() {
      if (
        Object.keys(this.user).length &&
        this.user.language !== this.Trans.currentLocale
      ) {
        if (!this.Trans.isLocaleSupported(this.user?.language)) {
          let to = this.$route
          this.Trans.changeLocale(this.Trans.defaultLocale).then(async () => {
            await this.fetchLocale(this.Trans.defaultLocale).then(() => {
              to = this.helpers.buildRoute({
                name: to.name,
                params: { ...to.params, locale: this.Trans.defaultLocale },
                query: to.query,
              })
              this.$router.push(to)
            })
          })
        } else {
          this.Trans.changeLocale(this.user.language).then(() => {
            this.$router.push(
              this.helpers.buildRoute({
                name: this.$route.name,
                params: {
                  ...this.$route.params,
                },
                query: this.$route.query,
              })
            )
          })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.choch {
  width: 100vw;
  height: 100%;
  background-color: #9bcbeb;
  &__header {
    &-first {
      margin-right: 30px;
      font-weight: 700;
      font-size: 236px;
      line-height: 200px;
      color: #ffffff;
      @media screen and (max-width: 1023px) {
        margin-right: 0;
        margin-bottom: 30px;
      }
      @media screen and (max-width: 767px) {
        font-size: 150px;
        line-height: 158px;
      }
    }
    &-second {
      max-width: 386px;
      &_title {
        font-weight: 600;
        font-size: 32px;
        line-height: 38px;
        color: #ffffff;
        @media screen and (max-width: 767px) {
          font-size: 24px;
          line-height: 32px;
        }
      }
      &_descr {
        font-weight: 400;
        font-size: 20px;
        line-height: 26px;
        color: #ffffff;
      }
    }
  }
  &__body {
    background-color: #f8f8f8;
    border-radius: 16px;
    padding: 42px 48px;
    @media screen and (max-width: 767px) {
      padding: 24px 32px;
    }
    &-title {
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
      color: #54585a;
      @media screen and (max-width: 767px) {
        font-size: 20px;
        line-height: 24px;
      }
    }
    &-list {
      padding-left: 25px;
      font-weight: 400;
      font-size: 20px;
      line-height: 26px;
      color: #54585a;
      list-style: decimal;
    }
  }
}
</style>
